import React from 'react';
import { logout } from '../../auth/services/AuthService';
import { useTranslations } from '../../localization/useTranslations';

const LogoutButton: React.FC = () => {
  const translations = useTranslations();
  return (
    <div className="account-dropdown__menu-item account-dropdown__menu-item--logout">
      <button
        id="logout"
        className="account-dropdown__logout-link link-16"
        onClick={logout}
        aria-label={translations?.accountNavigation?.logout || 'Logout'}
      >
        <div className="account-dropdown__menu-icon" />
        <span>{translations?.accountNavigation?.logout || 'Logout'}</span>
      </button>
    </div>
  );
};

export default LogoutButton;
